// Invitation « créer son mot de passe » (PER-2398).
// Éligibilité : même règle que l'API (jamais activé, jamais reçu d'email
// d'activation). Le serveur reste l'autorité : il répond 409 si le front se trompe.
export const estEligibleInvitation = (client) =>
  !!client && !client.isActivated && !client.activationTokenSendedAt;

export const libelleBoutonInvitation = (client) =>
  client && client.invitationSentAt
    ? "Renvoyer l'invitation"
    : "Envoyer l'invitation";
